
jQuery( 'img.svg' ).each( function() {
  var $img = jQuery( this );
  var imgID = $img.attr( 'id' );
  var imgClass = $img.attr( 'class' );
  var imgURL = $img.attr( 'src' );
  jQuery.get( imgURL, function( data ) {
    var $svg = jQuery( data ).find( 'svg' );
    if ( typeof imgID !== 'undefined' ) {
      $svg = $svg.attr( 'id', imgID );
    }
    if ( typeof imgClass !== 'undefined' ) {
      $svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
    }
    $svg = $svg.removeAttr( 'xmlns:a' );
    if ( !$svg.attr( 'viewBox' ) && $svg.attr( 'height' ) && $svg.attr( 'width' ) ) {
      $svg.attr( 'viewBox', '0 0 ' + $svg.attr( 'height' ) + ' ' + $svg.attr( 'width' ) );
    }
    $img.replaceWith( $svg );
  }, 'xml' );
} );


jQuery( "#footerScrollToTop" ).click( function() {
  jQuery( "html, body" ).animate( { scrollTop: 0 } );
  return false;
} );


jQuery( '.blog-listing .gallery-dots-container .gallery-prev' ).on( 'click', function() {
  let slider = jQuery( '#blogGallery' );
  slider.slick( 'slickPrev' );
} );


jQuery( '.blog-listing .gallery-dots-container .gallery-next' ).on( 'click', function() {
  let slider = jQuery( '#blogGallery' );
  slider.slick( 'slickNext' );
} );


if ( jQuery( '.ipad-and-content' ).length || jQuery( '.phone-and-content' ).length ) {
  let aim = document.getElementById( 'parallaxed-image' );
  let overflow;

  if (aim) {
    window.addEventListener( 'load', function() {

      let room = window.innerHeight;
      let space = room - aim.height;
      overflow = document.body.scrollHeight - room;

      aim.style.setProperty( '--maximum', space + 'px' );
    } );

    window.addEventListener( 'scroll', function() {
      let ratio = ( this.pageYOffset || this.scrollY ) / overflow;
  
      aim.style.setProperty( '--epoch', ratio );
    } );
  }
}



var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName( "custom-select" );
l = x.length;
for ( i = 0; i < l; i++ ) {
  selElmnt = x[i].getElementsByTagName( "select" )[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement( "DIV" );
  a.setAttribute( "class", "select-selected" );
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild( a );
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement( "DIV" );
  b.setAttribute( "class", "select-items select-hide" );
  for ( j = 1; j < ll; j++ ) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement( "DIV" );
    c.innerHTML = selElmnt.options[j].innerHTML;

    c.addEventListener( "click", function( e ) {
      /* When an item is clicked, update the original select box,
      and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName( "select" )[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for ( i = 0; i < sl; i++ ) {
        if ( s.options[i].innerHTML == this.innerHTML ) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName( "same-as-selected" );
          yl = y.length;
          for ( k = 0; k < yl; k++ ) {
            y[k].removeAttribute( "class" );
          }
          this.setAttribute( "class", "same-as-selected" );
          break;
        }
      }
      h.click();
    } );
    b.appendChild( c );
  }
  x[i].appendChild( b );
  a.addEventListener( "click", function( e ) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect( this );
    this.nextSibling.classList.toggle( "select-hide" );
    this.classList.toggle( "select-arrow-active" );
  } );
}

function closeAllSelect( elmnt ) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName( "select-items" );
  y = document.getElementsByClassName( "select-selected" );
  xl = x.length;
  yl = y.length;
  for ( i = 0; i < yl; i++ ) {
    if ( elmnt == y[i] ) {
      arrNo.push( i );
    } else {
      y[i].classList.remove( "select-arrow-active" );
    }
  }
  for ( i = 0; i < xl; i++ ) {
    if ( arrNo.indexOf( i ) ) {
      x[i].classList.add( "select-hide" );
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener( "click", closeAllSelect );


jQuery( document ).ready( function() {
  if ( jQuery( window ).width() < 768 ) {
    jQuery( '.blog-listing .gallery-dots-container' ).insertAfter( '#blogGalleryContainer' );
  }
} );


window.addEventListener( "pageshow", function( event ) {
  var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    window.location.reload();
  }
} );


if ( window.location.href.indexOf( "contact" ) > -1 ) {
  const inputDate = document.getElementById( "showroomDate" );
  inputDate.addEventListener( "focus", function( evt ) {
    if ( this.getAttribute( "type" ) === "date" ) {
      this.showPicker();
    }
  } );
}


jQuery( '#viewAllCaseStudies' ).on( 'click', function( e ) {
  if ( window.location.href.indexOf( "case-studies" ) > -1 ) {
    e.preventDefault();

    var offset = jQuery( '.blog-listing' ).offset();
    jQuery( 'html, body' ).animate( {
      scrollTop: offset.top - 150
    }, 200 );
  }

  if ( window.location.href.indexOf( "news" ) > -1 ) {
    e.preventDefault();

    var offset = jQuery( '.blog-listing' ).offset();
    jQuery( 'html, body' ).animate( {
      scrollTop: offset.top - 150
    }, 200 );
  }
} );